import { render, staticRenderFns } from "./MaterialRequirement.vue?vue&type=template&id=67a1aaf0"
import script from "./MaterialRequirement.vue?vue&type=script&lang=js"
export * from "./MaterialRequirement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports